import { lazy } from 'react';

const VerificatorPageCertifiedConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/verificator-certified',
			component: lazy(() => import('./VerificatorPageCertified'))
		}
	]
};

export default VerificatorPageCertifiedConfig;